/**
 * Redirects to the url carried by a `redirect-after-delay` browser event once the delay has passed,
 * leaving time for a toast to be read first.
 *
 * @param {number} delay Milliseconds.
 */
export default function delayedRedirect(delay = 4000) {
    return {
        redirect(event) {
            const url = Array.isArray(event.detail) ? event.detail[0] : event.detail?.url;

            if (url) {
                setTimeout(() => window.location.assign(url), delay);
            }
        },
    };
}
